import { PageHelmet } from 'components/common/PageHelmet';
import { StaffLayout } from '../StaffLayout';
import { ReportsBody, ReportsBodyProps } from './ReportsBody';

type ReportsLayoutProps = {
  title: string;
} & ReportsBodyProps;

export const ReportsLayout = ({ title, ...bodyProps }: ReportsLayoutProps) => {
  return (
    <StaffLayout>
      <PageHelmet title={title} />
      <ReportsBody {...bodyProps} />
    </StaffLayout>
  );
};
